module.exports = __webpack_public_path__ + "874b89b90aacc43c54882159de1427e9.svg";